<template>
    <v-container>
        <v-row>
            <div class="title">Report</div>
        </v-row>
        <v-row>
            <!-- <div>{{this.report.description}}</div> -->
            <!-- <v-text-field v-model="report.description" label="Beskrivelse" readonly></v-text-field> -->
            <v-textarea v-model="report.description" label="Beskrivelse" readonly auto-grow rows="1" :loading="reportLoading"></v-textarea>
            <v-divider vertical inset class="mx-2"></v-divider>
            <v-text-field :value="moment.unix(this.report.createdAt).format('YYYY-DD-MM HH:mm')" label="Dato" readonly :loading="reportLoading"></v-text-field>
            <!-- <div>{{moment.unix(this.report.createdAt).format("DD-MM-YYYY")}}</div> -->
        </v-row>

        <br>

        <v-row>
            <v-col :cols="12" :sm="6">

                <div class="body-1">Opplastninger:</div>
                <v-simple-table>

                    <template v-slot:default>

                        <thead>
                            <th>Filnavn</th>
                            <th>Åpne</th>
                        </thead>
                        <tbody>
                            <tr v-for="cnt in report.contents" :key="cnt.id">
                                <td>
                                    <div class="d-flex">
                                        <v-icon>
                                            {{cnt.type.includes("application")? "mdi-file-pdf-box" : "mdi-image"}}
                                        </v-icon>
                                        <div>
                                            {{cnt.name}}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <v-btn icon @click="showContent(cnt)">
                                        <v-icon>mdi-magnify-plus-outline</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

            </v-col>
            <v-col :cols="12" :sm="6">
                <div class="body-1">
                    Visning:
                    <v-btn small icon @click="openInNewWindow(content);" :disabled="!(content && content.type && content.type.length > 0)">
                        <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                </div>
                <div>
                    <v-img v-if="content && content.type && content.type.includes('image')" :src="content.src" contain height="500px"></v-img>
                    <iframe v-else-if="content && content.type && content.type.includes('application')" :src="`${content.fileURL}#view=Fit`" allowfullscreen="false" style="height: 500px; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                    <div v-else class="caption text-center">
                        <div>
                            Ingen visning
                        </div>
                    </div>

                    <v-progress-linear v-if="contentLoading" indeterminate></v-progress-linear>
                </div>
            </v-col>
        </v-row>
    </v-container>

    <!-- <div v-for="content in this.report.contents" :key="content.id">
                <div class="d-flex" style="align-items: center">
                    <div>{{content.name}}</div>
                    <v-btn icon :disabled="!content.src" @click="showContent(content)">
                        <v-icon v-if="!content.show" color="primary">mdi-magnify-plus-outline</v-icon>
                        <v-icon v-else color="primary">mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                    <v-img class="absolute" v-if="content.show && !content.fileURL" :src="content.src"></v-img>
                    <iframe v-if="content.show" :src="content.fileURL" frameborder="0"></iframe>
                </div>

            </div> -->
</template>

<script>
import * as axios from "axios";
import * as utils from "../utilities/utils";
import * as moment from "moment";
export default {
    props: ["id"],
    data() {
        return {
            report: {
                description: "laster...",
                createdAt: moment().unix()
            },
            reportLoading: false,
            content: {
                src: undefined
            },
            contentLoading: false,
            moment: moment
        };
    },
    computed: {
        mobile: function() {
            return utils.mobileAndTabletCheck();
        }
    },
    methods: {
        async showContent(content) {
            this.content = content;

            if (this.content.src && this.content.src.length > 0) {
                return;
            }

            this.$set(content, "src", await this.downloadContent(content));

            if (content.type.includes("application")) {
                let file = new Blob([Buffer.from(content.binary, "binary")], { type: "application/pdf" });
                let fileURL = URL.createObjectURL(file);
                this.$set(content, "fileURL", fileURL);
            }

            if (content.type.includes("image")) {
                let file = new Blob([Buffer.from(content.binary, "binary")], { type: content.type });
                let fileURL = URL.createObjectURL(file);
                this.$set(content, "fileURL", fileURL);
            }

            // if (content.type.startsWith("image")) {
            //     content.show ? (content.show = false) : (content.show = true);
            // } else {
            //     content.show ? (content.show = false) : (content.show = true);
            //     let file = new Blob([Buffer.from(content.binary, "binary")], { type: "application/pdf" });
            //     let fileURL = URL.createObjectURL(file);
            //     this.$set(content, "fileURL", fileURL);
            //     window.open(fileURL);
            //     console.log(navigator);
            // }
        },
        openInNewWindow(content) {
            window.open(content.fileURL);
        },
        async loadReport(id) {
            this.content = { src: undefined };
            this.reportLoading = true;
            try {
                let response = await axios.get(`/report/${id}`, {
                    params: {
                        include: "[createdBy,updatedBy,application,contents]"
                    }
                });
                this.report = response.data;
                this.reportLoading = false;
            } catch (error) {
                this.reportLoading = false;
                throw error;
            }
        },
        async downloadContent(content) {
            // this.$set(content, "show", false);

            this.contentLoading = true;

            try {
                let response = await axios.post(
                    `/report/download/stream`,
                    {
                        filepath: content.path
                    },
                    {
                        responseType: "arraybuffer"
                    }
                );

                let binary = response.data;
                this.$set(content, "binary", binary);

                let buffer = Buffer.from(binary, "binary").toString("base64");
                let src = `data:${response.headers["content-type"]};base64, ${buffer}`;

                this.contentLoading = false;

                return src;
            } catch {
                this.contentLoading = false;

                // console.log(err);
                return null;
            }
        }
    },
    watch: {
        id: {
            async handler(id) {
                this.loadReport(id);
            }
        }
    },
    async mounted() {
        if (this.id > 0) {
            this.loadReport(this.id);
        }
    }
};
</script>

<style lang="scss" scoped>
</style>>